define("Groups", [`Model`, `module`], function (Super, Self) {
	return Super.inherit({
		namespace: Self.id,
		requires: [`Events`, `Time`],
		singleton: true,
		api: {
			get: {
				async: true,
				public: true,
				defaults: {
					by: `id`,
				},
				value(context, options) {
					const { XHR } = this;
					switch (options.by) {
						case `id`: {
							const { id: groupId } = options;
							if (!this.isInt(groupId, 1)) {
								throw new Error(`Groups.get(): Unsigned int required for options.id`);
							}
							return this.cache(
								{
									type: `group`,
									key: groupId,
									force: options.force,
								},
								function () {
									return XHR.ajax({
										type: `GET`,
										url: `/api/groups/${groupId}`,
										then: this.normalize,
									});
								}
							); // returning, no break
						}

						default:
							throw new Error(`Groups.get(): Unrecognized options.by`);
					}
				},
			},

			getAll: {
				async: true,
				public: true,
				value(context, options) {
					return this.cache(
						{
							type: `all`,
							key: options.id,
							force: options.force,
						},
						function () {
							return this.XHR.ajax({
								type: `GET`,
								url: `/api/groups`,
							});
						}
					);
				},
			},

			getEventsById: {
				async: true,
				public: true,
				defaults: {
					block: true,
					force: false,
				},
				value(context, options) {
					const { Events, XHR } = this;
					const { block, force, id, page } = options;
					const type = `eventList`;
					let url = `/api/groups/${id}/events`;
					let key = `${id}`;

					if (this.isInt(page, 1)) {
						url += `?page=${page}`;
						key += `-${page}`;
					}

					return this.cache({ type, key, force }, () =>
						XHR.ajax({
							type: `GET`,
							url,
							block,
							dataType: `json`,
							then: (response) => this.each(response, Events.normalize),
						})
					);
				},
			},

			getCalendarPages: {
				async: true,
				public: true,
				defaults: {
					force: false,
				},
				value(context, options) {
					const { XHR } = this;
					const { force, id } = options;
					const type = `groupCalendarPages`;
					const key = id;

					return this.cache({ type, key, force }, () =>
						XHR.ajax({
							type: `GET`,
							url: `/api/groups/${id}/calendar-months`,
						})
					);
				},
			},

			getCalendarPage: {
				async: true,
				public: true,
				defaults: {
					force: false,
				},
				value(context, options) {
					const { XHR } = this;
					const { force, id, month, year } = options;
					const type = `groupCalendarPage`;
					const key = `${id}-${year}-${month}`;

					return this.cache({ type, key, force }, () => {
						const type = `GET`;
						const url = `/api/groups/${id}/calendars/${year}/months/${month}`;

						return XHR.ajax({ type, url });
					});
				},
			},

			getGroupSale: {
				async: true,
				public: true,
				defaults: {
					force: false,
				},
				value(context, options) {
					const { XHR } = this;
					const { force, groupId, id } = options;
					const type = `groupSale`;
					const key = id;

					return this.cache({ type, key, force }, () =>
						XHR.ajax({
							type: `GET`,
							url: `/api/groups/${groupId}/group-sales/${id}`,
						})
					);
				},
			},

			getGroupSaleEvents: {
				async: true,
				public: true,
				defaults: {
					force: false,
				},
				value(context, options) {
					const { XHR } = this;
					const { force, groupId, id } = options;
					const type = `groupSaleEvents`;
					const key = id;

					return this.cache({ type, key, force }, () =>
						XHR.ajax({
							type: `GET`,
							url: `/api/groups/${groupId}/group-sales/${id}/events`,
						})
					);
				},
			},

			applyGroupSaleAccessCode: {
				async: true,
				public: true,
				defaults: {
					force: false,
				},
				value(context, options) {
					const { XHR } = this;
					const { accessCode, groupId, id } = options;

					return XHR.ajax({
						type: `GET`,
						url: `/api/groups/${groupId}/group-sales/${id}/locks/${accessCode}`,
					});
				},
			},

			normalize: {
				public: true,
				value(caller, group) {
					const { Utils } = this;
					const { hiddenDetails, id, logoUrl } = group;
					const hiddenDetailsList = this.isString(hiddenDetails) ? hiddenDetails.split(`,`) : [];
					const trackingId = `g${id}`;

					this.assign(group, { hiddenDetailsList, trackingId });

					if (this.isString(logoUrl, 1)) {
						const lastSlashIndex = logoUrl.lastIndexOf(`/`);
						group.logoThumbnailUrl = Utils.insertAt(logoUrl, lastSlashIndex, `/thumbnail`);
					}

					return group;
				},
			},
		},
	});
});

//# sourceMappingURL=Groups.js.map